// src/services/authService.js
// import axios from "axios";
import api from "@/api";

// const API_LOGIN_VRABOTEN = "https://nalozi.megasoft.com.mk/api/login/vraboteni";


/*  LOGIN за вработени преку API */
export async function loginVraboten(username, password) {
  try {
    // const res = await axios.post(API_LOGIN_VRABOTEN, {
    //   username,
    //   password
    // });
    const res = await api.post("/login/vraboteni", {
      username,
      password
    });

    //  го снимаме корисникот локално
    if (res.data) {
      localStorage.setItem("user", JSON.stringify(res.data));
    }

    return res.data;

  } catch (err) {
    if (err.response?.data) {
      throw err.response.data;
    }
    throw { message: "Погрешно корисничко име или лозинка" };
  }
}

/*  READ user   */

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem("user")) || null;
  } catch {
    return null;
  }
}

/*  GET ROLE (СистемОператор / Вработен / Клиент)   */
export function getUserRole() {
  const user = getUser();
  return user ? user.uloga : null;
}

/*  LOGOUT  */
export function logout() {
  localStorage.removeItem("user");
}
